import { Component } from '@angular/core';
import { ApiService } from '../../services/Api.service';
import { GoogleAnalyticsService } from '../../services/googleAnalytics.service';

@Component({
  selector: 'app-categories',
  standalone: false,
  templateUrl: './categories.component.html'
})
export class CategoriesComponent {
  dataLoading = true;
  domains: any;

  constructor(
    private apiService: ApiService,
    public analytics: GoogleAnalyticsService
  ) {
    this.getData();
  }

  getData() {
    let domainFilter = { perPage: 999, page: 1 };
    this.apiService.getDomains(domainFilter).subscribe((res: any) => {
      this.domains = res;
      this.dataLoading = false;
    })
  }
  trackSource(source: string, item: any) {
    this.analytics.event(source, {
      id: item.id,
      name: item.name
    });
  }

}
